// Penalty history for the Player Finder card's Penalty section: one count per
// month for the last 12 months. The BE field is not shipped yet, so this is
// mock-first — flip USE_MOCK_PENALTIES + wire the real field in one place.

export interface PenaltyPoint {
  /** Month in ISO 'YYYY-MM' form, e.g. '2026-07'. */
  month: string
  /** Penalty count for that month. */
  penalties: number
}

// When true, the card shows MOCK_PENALTIES. Flip to false once the BE returns a
// real penalty history on the candidate/player response.
export const USE_MOCK_PENALTIES = true

const MONTH_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

/** 'YYYY-MM' → short month label ('2026-07' → 'Jul'). Falls back to the raw
 * string if it can't be parsed. */
export const monthShortLabel = (month: string): string => {
  const parts = (month ?? '').split('-')
  const m = Number(parts[1])
  if (!m || m < 1 || m > 12) {
    return month
  }
  return MONTH_SHORT[m - 1]
}

// 12 chronological months (oldest → newest) with small plausible counts. Static
// (no Date/random) so it's deterministic and test-friendly.
export const MOCK_PENALTIES: PenaltyPoint[] = [
  { month: '2025-08', penalties: 1 },
  { month: '2025-09', penalties: 3 },
  { month: '2025-10', penalties: 2 },
  { month: '2025-11', penalties: 4 },
  { month: '2025-12', penalties: 0 },
  { month: '2026-01', penalties: 2 },
  { month: '2026-02', penalties: 5 },
  { month: '2026-03', penalties: 3 },
  { month: '2026-04', penalties: 1 },
  { month: '2026-05', penalties: 4 },
  { month: '2026-06', penalties: 2 },
  { month: '2026-07', penalties: 3 },
]

/** Resolve the penalty history for a candidate. Returns the mock while the BE
 * field is pending; swap the real source in here when USE_MOCK_PENALTIES flips.
 */
export const resolvePenalties = (
  real?: PenaltyPoint[] | null
): PenaltyPoint[] => {
  if (USE_MOCK_PENALTIES) {
    return MOCK_PENALTIES
  }
  return real ?? []
}
